const Mining = () => {
  return (
    <div>
      <h4>Mining combined goes here</h4>
      <p>Combined information from text mining goes here</p>
    </div>
  )
}

export default Mining
